export type AuthorityGroupPolicy = {
    admin?: boolean,
    user?: boolean,
}

export const CreateTopicAuthorityGroupPolicyDefault = { admin: true,  user: true };
export const UpdateTopicAuthorityGroupPolicyDefault = { admin: false };